import { createSelector } from "@reduxjs/toolkit";
import { Selector } from "react-redux";

export function createEntitySelectors<TEntity, TId extends string>(
  rootSelector: Selector<any, Record<TId, TEntity>>,
  keys: readonly TId[],
): Record<TId, Selector<any, TEntity>> {
  const selectors = {} as Record<TId, Selector<any, TEntity>>;

  keys.forEach((key) => {
    selectors[key] = createSelector(
      [rootSelector],
      (stateMap): TEntity => stateMap[key],
    );
  });

  return selectors;
}
